import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';
import { schemaEuropaceAntragstellerzuordnung } from '../../Antragstellerzuordnung.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#kontokorrentkredit

	{
		"beanspruchterBetrag": schemaBigDecimal
		"gehoertZuAntragsteller": Antragstellerzuordnung,
		"glaeubiger": String,
		"verfuegungsrahmen": schemaBigDecimal,
		"zinssatz": schemaBigDecimal
	}

*/
export const schemaEuropaceKontokorrentkredit = z.object({
    beanspruchterBetrag: z.optional(schemaBigDecimal),
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(schemaEuropaceAntragstellerzuordnung),
    glaeubiger: z.optional(z.string()),
    id: z.string().min(1),
    verfuegungsrahmen: z.optional(schemaBigDecimal),
    zinssatz: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceKontokorrentkredit = z.infer<typeof schemaEuropaceKontokorrentkredit>;
